import { combineReducers } from '@ngrx/store';
import * as fromJobsite from './jobsite-reducer/jobsite.reducer';
import * as fromHauler from './hauler-reducer/hauler.reducer';
import * as fromPointOfDelivery from './point-of-delivery-reducer/point-of-delivery.reducer';
import * as fromAnticipatedInvoice from './anticipated-invoice-reducer/anticipated-invoice.reducer';
import * as fromPurchaseOrder from './purchase-order-reducer/purchase-order.reducer';
import * as fromSpecialInstructions from './special-instructions-reducer/special-instructions.reducer';
import * as fromLocationMap from './location-map-reducer/location-map.reducer';
import * as fromCalendars from './calendar-reducer/calendars.reducer';
import * as fromExperiences from './experiences-reducer/experiences.reducer';
import * as fromNewReceivingPerson from '@ordersnproducts/modules/shared/modules/receiving-person/redux/reducers/new-receiving-person.reducer';
import * as fromInternalComments from './internal-comments-reducer/internal-comments.reducer';

/**
 * The user inputs and other state values associated with the location page of the order-builder.
 */
export interface LocationPageState {
  jobsite: fromJobsite.IJobsiteState;
  hauler: fromHauler.IHaulerState;
  pointOfDelivery: fromPointOfDelivery.IPointOfDeliveryState;
  anticipatedInvoice: fromAnticipatedInvoice.IAnticipatedInvoiceState;
  purchaseOrder: fromPurchaseOrder.IPurchaseOrderState;
  specialInstructions: fromSpecialInstructions.ISpecialInstructionState;
  locationMap: fromLocationMap.ILocationMapState;
  calendars: fromCalendars.CalendarsState;
  experiences: fromExperiences.State;
  newReceivingPerson: fromNewReceivingPerson.NewReceivingPersonState;
  internalComments: fromInternalComments.IInternalCommentsState;
}

export const reducers = combineReducers({
  jobsite: fromJobsite.jobsiteReducer,
  hauler: fromHauler.haulerReducer,
  pointOfDelivery: fromPointOfDelivery.pointOfDeliveryReducer,
  anticipatedInvoice: fromAnticipatedInvoice.anticipatedInvoiceReducer,
  purchaseOrder: fromPurchaseOrder.purchaseOrderReducer,
  specialInstructions: fromSpecialInstructions.specialInstructionsReducer,
  locationMap: fromLocationMap.locationMapReducer,
  calendars: fromCalendars.CalendarsReducer,
  experiences: fromExperiences.reducer,
  newReceivingPerson: fromNewReceivingPerson.reducer,
  internalComments: fromInternalComments.internalCommentsReducer,
});
